'use strict';

var redux = require('redux');

var loadingStateReducerFactory = function loadingStateReducerFactory() {
    for (var _len = arguments.length, triggerLoadActionTypes = Array(_len), _key = 0; _key < _len; _key++) {
        triggerLoadActionTypes[_key] = arguments[_key];
    }

    return function () {
        for (var _len2 = arguments.length, haltLoadActionTypes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            haltLoadActionTypes[_key2] = arguments[_key2];
        }

        /* State shape
         {
             loadingState: {
                 isLoading: bool,
                 hasLoaded: bool,
                 success: bool,
                 errors: Array
             }
         }
         */

        var isLoadingReducer = function isLoadingReducer() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var action = arguments[1];

            if (triggerLoadActionTypes.includes(action.type)) {
                return true;
            } else if (haltLoadActionTypes.includes(action.type)) {
                return false;
            }

            return state;
        };

        var hasLoadedReducer = function hasLoadedReducer() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var action = arguments[1];

            if (haltLoadActionTypes.includes(action.type)) {
                return true;
            } else if (triggerLoadActionTypes.includes(action.type)) {
                return false;
            }

            return state;
        };

        var successReducer = function successReducer() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var action = arguments[1];

            if (haltLoadActionTypes.includes(action.type)) {
                return action.payload.success;
            }

            return state;
        };

        var errorsReducer = function errorsReducer() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var action = arguments[1];

            if (haltLoadActionTypes.includes(action.type)) {
                return action.payload.errors;
            }

            return state;
        };

        return redux.combineReducers({
            isLoading: isLoadingReducer,
            hasLoaded: hasLoadedReducer,
            success: successReducer,
            errors: errorsReducer
        });
    };
};

module.exports = loadingStateReducerFactory;
